<template>
  <div id="app">
    <Header/>
    <div class="mb-content-wrap">
      <div class="mb-content">
        <router-view/>
      </div>
    </div>

    <vue-progress-bar/>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'

  import {
    detectLanguageCode,
  } from '@/mixins/languageCode'

  export default {
    mixins: [
      detectLanguageCode,
    ],
    components: {
      Header,
    },
    mounted() {
      this.$Progress.finish()
    },
    created() {
      this.detectLanguageCode()

      this.$Progress.start()

      this.$router.beforeEach((to, from, next) => {
        if (from.path === to.path) {
          // поменялась только query
          return next()
        }
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
      this.$router.afterEach(() => {
        this.$Progress.finish()
      })
    }
  }
</script>

<style>
  .bc0 { background-color: #294659; } .tc0 { color: #294659; }
  .bc1 { background-color: #e56555; } .tc1 { color: #ca5650; }
  .bc2 { background-color: #f28c48; } .tc2 { color: #d87b29; }
  .bc3 { background-color: #8e85ee; } .tc3 { color: #7170d5; }
  .bc4 { background-color: #76c84d; } .tc4 { color: #50b232; }
  .bc5 { background-color: #5fbed5; } .tc5 { color: #55a8bd; }
  .bc6 { background-color: #549cdd; } .tc6 { color: #4e92cc; }
  .bc7 { background-color: #f2749a; } .tc7 { color: #e5638a; }
  .bc8 { background-color: #d1b04d; } .tc8 { color: #ae9038; }
</style>

<style lang="stylus">
  *
    box-sizing border-box
    font-family inherit

  body
    font-family Roboto, Helvetica, Arial, sans-serif
    color: #212529
    margin 0 auto
    font-size 14px

  #app
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale

  .mb-content-wrap
    margin 59px 15px 15px
    display flex
    flex-direction column
    align-items center
    @media (min-width: 510px)
      margin-bottom 30px

  .mb-content
    width 100%
    max-width 480px

  a
    text-decoration none
    color #0088cc

    &:hover
      color #0088cc

    &:not(:hover)
      transition color .25s

  .vgs__container
    height auto !important
    margin 0 auto !important
    border-radius 0 !important
    top 50%!important
    transform translateY(-50%)

  .vgs__gallery
    display  none !important

  .radio-item,
  .checkbox-item
    display inline-block
    vertical-align top
    margin-bottom 0
    font-size 14px
    line-height 20px
    font-weight normal
  .radio-item-block,
  .checkbox-item-block
    display block
    margin 6px 0 1px
    padding 5px 0
    line-height 20px
  .radio-item-block + .radio-item-block,
  .checkbox-item-block + .checkbox-item-block
    margin-top 1px
  .radio-item input.radio,
  .checkbox-item input.checkbox
    position absolute
    left -5000px
  .radio-item input.radio ~ .radio-label,
  .checkbox-item input.checkbox ~ .checkbox-label
    display inline-block
    -webkit-user-select none
    -moz-user-select none
    -ms-user-select none
    -o-user-select none
    user-select none
    max-width calc(100% - 31px)
  .radio-item .radio-input,
  .checkbox-item .checkbox-input
    display inline-block
    vertical-align top
    position relative
    -webkit-user-select none
    -moz-user-select none
    -ms-user-select none
    -o-user-select none
    user-select none
    transition opacity 0.12s linear
  .radio-item .radio-input + .radio-label,
  .checkbox-item .checkbox-input + .checkbox-label
    margin-left 11px
  .radio-item .radio-input-icon,
  .checkbox-item .checkbox-input-icon
    display inline-block
    content ''
    width 20px
    height 20px
    border 2px solid #b3b3b3
    background #fff
    border-radius 10px
    vertical-align top
    padding 0
    cursor pointer
    position relative
  .radio-item .radio-input-icon:before,
  .checkbox-item .checkbox-input-icon:before
    display inline-block
    content ''
    position absolute
    width 20px
    height 20px
    border 2px solid #54a9eb
    border-radius 10px
    top -2px
    left -2px
    transition opacity 0.12s linear
    opacity 0
  .radio-item
    .radio-input-icon
      &:after
        display inline-block
        content ''
        position absolute
        width 10px
        height 10px
        background #54a9eb
        border-radius 5px
        top 3px
        left 3px
        transition transform 0.12s linear
        transform scale3d(0, 0, 1)
    input
      &.radio
        &:checked
          & + .radio-input
            .radio-input-icon
              &:after
                transform scale3d(1, 1, 1)
  .radio-item input.radio:checked + .radio-input .radio-input-icon:before,
  .checkbox-item input.checkbox:checked + .checkbox-input .checkbox-input-icon:before
    opacity 1
  .checkbox-item .checkbox-input-icon,
  .checkbox-item .checkbox-input-icon:before
    width 18px
    height 18px
    margin 1px
    border-radius 3px
  .checkbox-item
    .checkbox-input-icon
      &:before
        margin 0
        background #54a9eb url(/img/rc_icons.png) no-repeat -3px -91px
        background-clip content-box
  .radio-item input.radio:disabled + .radio-input,
  .checkbox-item input.checkbox:disabled + .checkbox-input
    cursor default
    pointer-events none
    opacity .65
</style>

<style>
  .btn,
  a.btn,
  button.btn {
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    border-radius: 5px;
    padding: 8px 16px 6px;
    border: none;
  }
  .btn:active {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.125);
  }
  .btn-xs,
  a.btn-xs,
  button.btn-xs {
    font-size: 11px;
    line-height: 14px;
    padding: 4px 7px 2px;
  }
  .btn-sm,
  a.btn-sm,
  button.btn-sm {
    padding: 5px 14px 4px;
  }
  .btn-lg,
  a.btn-lg,
  button.btn-lg {
    padding: 9px 16px 8px;
  }
  .btn-primary {
    background-color: #238fe1;
  }
  .btn-primary:hover,
  .btn-primary:focus,
  .btn-primary:active {
    background-color: #068cd4;
  }
  .btn-default {
    background-color: transparent;
    color: #0086d3;
  }
  .btn-default:hover,
  .btn-default:focus,
  .btn-default:active,
  .open > .dropdown-toggle.btn-default {
    color: #0086d3;
    background-color: #e8f3fa;
    box-shadow: none;
  }
  .btn-default.btn-danger {
    color: #d14e4e;
    background-color: transparent;
  }
  .btn-default.btn-danger:hover,
  .btn-default.btn-danger:focus,
  .btn-default.btn-danger:active {
    color: #d14e4e;
    background-color: #fcdfde;
  }
  .btn-link:active {
    box-shadow: none;
  }
  .btn-muted {
    color: #1a1a1a;
    background-color: #f2f2f2;
  }

  .btn:focus,
  .btn:active:focus,
  button:focus,
  button:active:focus,
  input.form-control:focus,
  textarea.form-control:focus,
  input.form-control,
  textarea.form-control {
    outline: none;
    box-shadow: none;
  }
  input.form-control[disabled],
  textarea.form-control[disabled] {
    cursor: auto;
    background-color: #fff;
  }
</style>
